import { render, staticRenderFns } from "./leaders.vue?vue&type=template&id=1457a2b6"
import script from "./leaders.vue?vue&type=script&lang=js"
export * from "./leaders.vue?vue&type=script&lang=js"
import style0 from "./leaders.vue?vue&type=style&index=0&id=1457a2b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports